export const letters = [
  { character: 'a', variation: 'á' },
  { character: 'b', variation: '' },
  { character: 'c', variation: 'ç' },
  { character: 'd', variation: '' },
  { character: 'e', variation: 'é' },
  { character: 'f', variation: '' },
  { character: 'g', variation: '' },
  { character: 'h', variation: '' },
  { character: 'i', variation: 'í' },
  { character: 'j', variation: '' },
  { character: 'k', variation: '' },
  { character: 'l', variation: '' },
  { character: 'm', variation: '' },
  { character: 'n', variation: '' },
  { character: 'ñ', variation: '' },
  { character: 'o', variation: 'ó' },
  { character: 'p', variation: '' },
  { character: 'q', variation: '' },
  { character: 'r', variation: '' },
  { character: 's', variation: '' },
  { character: 't', variation: '' },
  { character: 'u', variation: 'ú' },
  { character: 'v', variation: '' },
  { character: 'w', variation: '' },
  { character: 'x', variation: '' },
  { character: 'y', variation: '' },
  { character: 'z', variation: '' },
];

export const numbers = [
  { character: '1', variation: '' },
  { character: '2', variation: '' },
  { character: '3', variation: '' },
  { character: '4', variation: '' },
  { character: '5', variation: '' },
  { character: '6', variation: '' },
  { character: '7', variation: '' },
  { character: '8', variation: '' },
  { character: '9', variation: '' },
  { character: '0', variation: '' },
];
